import { h } from "preact";
import firstEligibleDiscountMessage from "./firstEligibleDiscountMessage";
import parseDiscountMessage from "./parseDiscountMessage";
import { TIER_TYPES } from "./tierTypes";

const injectMessage = ({ message, quantity, percentage }) => {
  return message
    .replace("[quantity]", quantity)
    .replace("[percentage]", percentage);
};

export default function MiniCartBundleProgress({ items, currency }) {
  const discountMessage = firstEligibleDiscountMessage(
    items[0]?.additionalData?.merchandise?.discountMessages,
  );

  if (!discountMessage) return null;

  const parsedDiscountMessage = parseDiscountMessage(discountMessage);

  if (!parsedDiscountMessage) return null;

  const {
    bundleTitle,
    message,
    successMessage,
    minimumQuantityTiers,
    percentageOffTiers,
    tierType,
  } = parsedDiscountMessage;

  const totalQuantity = items.reduce((count, item) => {
    if (tierType === TIER_TYPES.Quantity) {
      return count + item.quantity;
    }

    return count + item.final_line_price / 100;
  }, 0);

  let currentTier = null;
  let nextTier = 0;

  minimumQuantityTiers.forEach((tier, i) => {
    if (totalQuantity >= tier) {
      currentTier = i;
      nextTier = i + 1 < minimumQuantityTiers.length ? i + 1 : null;
    }
  });

  let successMessageText = null;
  let messageText = null;

  const formatQuantity = (quantity) =>
    tierType === TIER_TYPES.Quantity
      ? quantity
      : window.formatMoney(quantity, false, currency);

  if (currentTier !== null) {
    successMessageText = injectMessage({
      message: successMessage,
      quantity: formatQuantity(totalQuantity),
      percentage: percentageOffTiers[currentTier],
    });
  }

  if (nextTier !== null) {
    messageText = injectMessage({
      message,
      quantity: formatQuantity(minimumQuantityTiers[nextTier] - totalQuantity),
      percentage: percentageOffTiers[nextTier],
    });
  }

  const messages = [successMessageText, messageText]
    .filter((text) => text)
    .join(", ");

  const progressItemCount =
    minimumQuantityTiers[nextTier !== null ? nextTier : currentTier];

  return (
    <div className="mini-cart-bundle">
      <div className="mini-cart-bundle__title">{bundleTitle}</div>
      <div className="mini-cart-bundle__content">
        <div>{messages}</div>
        <div>
          {tierType === TIER_TYPES.Quantity
            ? window.localeStrings.cart.bundle_quantity_added.replace(
                "[count]",
                totalQuantity,
              )
            : window.localeStrings.cart.bundle_price_tier.replace(
                "[total]",
                formatQuantity(progressItemCount),
              )}
        </div>
      </div>
      {tierType === TIER_TYPES.quantity ? (
        <div className="mini-cart-bundle__progress">
          {new Array(progressItemCount).fill(null).map((_, i) => (
            <div
              className={`mini-cart-bundle__progress-item ${i < totalQuantity ? "mini-cart-bundle__progress-item--filled" : ""}`}
            ></div>
          ))}
        </div>
      ) : (
        <div className="mini-cart-bundle__progress-bar">
          <div
            className="mini-cart-bundle__progress-bar-inner"
            style={{
              "--progress": Math.min(totalQuantity / progressItemCount, 1),
            }}
          ></div>
        </div>
      )}
    </div>
  );
}
